import { isEmpty, isUndefined } from 'lodash';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ReportStudioPageMetadata } from '@/modules/ta/reportstudio/models/ReportStudioPageMetadata';
import { ReportStudioPageMetadataFactory } from '@/modules/ta/reportstudio/factories/ReportStudioPageMetadataFactory';
import { ReportStudioElement } from '@/modules/ta/reportstudio/models/ReportStudioElement';

export class ReportStudioPage extends BaseEntityModel {
  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  report_id;

  /**
   * @var {string}
   */
  title;

  /**
   * @var {boolean}
   */
  is_cover_page;

  /**
   * @var {boolean}
   */
  is_back_page;

  /**
   * @var {string}
   */
  metadata;

  /**
   * @var {number}
   */
  page_index;

  /**
   * @var {datetime}
   */
  created_at;

  /**
   * @var {datetime}
   */
  updated_at;

  /**
   * @var {boolean}
   */
  is_deleted;

  /**
   * @var {Array}
   */
  elements;

  /**
   * @var {boolean}
   */
  has_granular_permissions;

  /**
   * @var {object}
   */
  granular_access_levels;

  /**
   * @var {boolean}
   */
  is_executive_summary_page;

  /**
   * @var {boolean}
   */
  executive_summary_enabled;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.report_id = model.report_id;
    this.title = model.title;
    this.is_cover_page = model.is_cover_page ?? false;
    this.is_back_page = model.is_back_page ?? false;
    this.metadata = isEmpty(model.metadata)
      ? ReportStudioPageMetadataFactory.buildDefault()
      : new ReportStudioPageMetadata(model.metadata);
    this.page_index = model.page_index;
    this.created_at = model.created_at;
    this.updated_at = model.updated_at;
    this.is_deleted = model.is_deleted;
    this.elements = (model.elements ?? []).map((element) => new ReportStudioElement(element));
    this.has_granular_permissions = model.has_granular_permissions;
    this.granular_access_levels = model.granular_access_levels || {};
    this.is_executive_summary_page = !isUndefined(model.is_executive_summary_page)
      ? model.is_executive_summary_page
      : false;
    this.executive_summary_enabled = !isUndefined(model.executive_summary_enabled)
      ? model.executive_summary_enabled
      : false;
  }

  /**
   *
   * @param title
   */
  setTitle(title) {
    this.title = title;
  }

  /**
   *
   * @param index
   */
  setPageIndex(index) {
    this.page_index = index;
  }

  /**
   *
   * @param color
   */
  setBackgroundColor(color) {
    this.metadata.design_options.background_color = color;
  }
}
